import { Component, Input, ViewEncapsulation } from '@angular/core';

import * as atlas from 'azure-maps-control';
import { LocationMapService } from './location-map.service';

@Component({
  selector: 'app-location-map',
  templateUrl: './location-map.component.html',
  styleUrls: ['./location-map.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class LocationMapComponent {
  @Input()
  public set addressCoordinates(value: [number, number]) {
    if (
      value &&
      !this.areCoordinatesEqual(value, this.currentLocationCoordinates)
    ) {
      this.setCoordinates(value);
    }
  }

  public map: atlas.Map;
  public currentLocationCoordinates?: [number, number] = [0, 0];

  constructor(private mapsService: LocationMapService) {}

  private areCoordinatesEqual(
    coord1: [number, number],
    coord2?: [number, number]
  ): boolean {
    if (!coord2) return false;
    return coord1[0] === coord2[0] && coord1[1] === coord2[1];
  }

  private async setCoordinates(addressCoordinates: [number, number]) {
    this.currentLocationCoordinates = addressCoordinates;

    console.log(
      ' [LocationMapComponent] currentLocationCoordinates',
      this.currentLocationCoordinates
    );

    if (this.map) {
      this.map.dispose();
    }

    this.map = new atlas.Map('azure-map', {
      ...this.mapsService.DefaultOptions,
      disableTelemetry: true,
      center: this.currentLocationCoordinates,
      style: 'satellite',
    });

    this.map.events.add('ready', async () => {
      const dataSource = new atlas.source.DataSource();
      this.map.sources.add(dataSource);

      const point = new atlas.Shape(
        new atlas.data.Point(
          new atlas.data.Position(
            this.currentLocationCoordinates![0],
            this.currentLocationCoordinates![1]
          )
        )
      );

      dataSource.add([point]);
      this.map.layers.add(new atlas.layer.SymbolLayer(dataSource));
    });
  }
}
